import {
  type ICore,
  KunduzCountry,
  useCountries,
} from "@kunduz/data-access-core-api";
import { useEffect, useState } from "react";
import { ILocaleInfo, getLocale } from "./localizationService";
import { SiteLangEnum } from "@kunduz/utility-common";

export function useLocale(options: { lang?: SiteLangEnum }) {
  const { countries, countriesError, countriesLoading } = useCountries(
    options.lang,
  );
  const [locale, setLocale] = useState<ILocaleInfo>();
  const [selectedCountry, setSelectedCountry] = useState<ICore.ICountry>();

  useEffect(() => {
    if (!countries) return;
    if (!options?.lang) return;

    const _locale = getLocale({
      i18nextLocale: options.lang,
    });

    const _c = countries
      .map((x) => new KunduzCountry(x))
      .find((x) => x.i18_iso_code === _locale?.i18nextLocale);

    setLocale(_locale);
    setSelectedCountry(_c);
  }, [countries, options.lang]);

  return {
    countries,
    countriesError,
    countriesLoading,
    locale,
    selectedCountry,
  };
}
